import script from "./UnsupportedBrowser.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnsupportedBrowser.vue?vue&type=script&setup=true&lang=ts"

import "./UnsupportedBrowser.vue?vue&type=style&index=0&id=3c83681a&lang=scss"

const __exports__ = script;

export default __exports__